import DaynamicForm from 'src/pages/DemoPage/form';
import DemoPage from 'src/pages/DemoPage/index';

export const demoRoutes = [
  { path: '/demo', component: DemoPage },
  { path: '/demo/add', component: DaynamicForm },
  { path: '/demo/update/:id', component: DaynamicForm },
];
